export enum EComparisonOperator {
  EQ = '=',
  IN = 'IN',
  LIKE = 'LIKE',
  GROUP = 'GROUP',
}

export enum EGroupOperator {
  OR = 'OR',
  AND = 'AND',
}

export type IExtraConditionEq = {
  operator: EComparisonOperator.EQ;
  fields: string[];
  value: string | number;
  groupOperator?: EGroupOperator;
};

export type IExtraConditionIn = {
  operator: EComparisonOperator.IN;
  fields: string[];
  values: Array<string | number>;
  groupOperator?: EGroupOperator;
};

export type IExtraConditionLike = {
  operator: EComparisonOperator.LIKE;
  fields: string[];
  value: string;
  groupOperator?: EGroupOperator;
};

export type IExtraConditionGroup = {
  operator: EComparisonOperator.GROUP;
  groupOperator: EGroupOperator;
  conditions: IExtraCondition[];
};

export type IExtraCondition =
  | IExtraConditionEq
  | IExtraConditionIn
  | IExtraConditionLike
  | IExtraConditionGroup;
